
import { FormState__startLoading, FormState__setValidationResponse_5219762A, FormState_get_empty } from "../../../Shared/Shared.js";
import { ofArray, empty } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Msg, State } from "./Types.js";
import { Cmd_none } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_successToast, Cmd_errorToast } from "../../../Components/Toast.js";
import { Cmd_OfPromise_either } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { ensureRequestBodySize } from "../../../ErrorHandling.js";
import { promise } from "../../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../../CommunicationV2.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { RowValidation_$reflection } from "../../../Shared/Updater.js";
import { string_type, list_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { onBlobReceived } from "../../../CommunicationV2.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";

export function init() {
    return [new State(FormState_get_empty(), empty()), Cmd_none()];
}

export function update(msg, state) {
    switch (msg.tag) {
        case 1: {
            const response_2 = msg.fields[0];
            if (response_2.tag === 1) {
                return [new State(FormState__setValidationResponse_5219762A(state.FormState, response_2.fields[0]), state.Rows), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(FormState_get_empty(), state.Rows), Cmd_successToast("general.saved_successfully")];
            }
        }
        case 2:
            return [new State(FormState__startLoading(state.FormState), state.Rows), Cmd_OfPromise_either((tupledArg_1) => {
                const formData_2 = tupledArg_1[1];
                return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    let url_5;
                    ensureRequestBodySize(formData_2);
                    return ((url_5 = addPrefix(tupledArg_1[0]), (refreshOn_1) => fetchWithDecoder(url_5, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [formData_2])]), undefined, (response_3) => {
                        const pr_1 = response_3.arrayBuffer();
                        return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), list_type(RowValidation_$reflection())));
                    }, refreshOn_1)))(true);
                }));
            }, ["/api/update/tools/validate", msg.fields[0]], (Item_2) => (new Msg(3, [Item_2])), (Item_3) => (new Msg(5, [Item_3])))];
        case 3: {
            const response_5 = msg.fields[0];
            if (response_5.tag === 1) {
                return [new State(FormState__setValidationResponse_5219762A(state.FormState, response_5.fields[0]), state.Rows), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(FormState_get_empty(), response_5.fields[0]), Cmd_none()];
            }
        }
        case 4: {
            onBlobReceived(msg.fields[0], msg.fields[1]);
            return [state, Cmd_none()];
        }
        case 5:
            return [new State(FormState_get_empty(), state.Rows), Cmd_errorToast("validation.toast")];
        default:
            return [new State(FormState__startLoading(state.FormState), state.Rows), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_2;
                return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
                    const pr = response.arrayBuffer();
                    return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
                }, refreshOn)))(true);
            })), ["/api/update/tools", toString(0, Auto_generateBoxedEncoder_437914C6(list_type(RowValidation_$reflection()), undefined, undefined, undefined)(state.Rows))], (Item) => (new Msg(1, [Item])), (Item_1) => (new Msg(5, [Item_1])))];
    }
}

